var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBackIos = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.281 8.53a1.046 1.046 0 0 0 0 1.426l7.946 8.351a.57.57 0 0 0 .83 0l.528-.555a.643.643 0 0 0 .002-.87l-7.27-7.638 7.27-7.64a.64.64 0 0 0-.002-.87l-.528-.555a.57.57 0 0 0-.83 0z"
})));
export default SvgIconBackIos;